import {
  Button,
  Input,
  ModalBody,
  ModalFooter,
  Stack,
  Checkbox,
  Text,
} from "@chakra-ui/react";

export default function SIPForm({
  widgetForm,
  onSubmit,
  loadingStatus,
  onBack,
}) {
  const { register, watch } = widgetForm;

  const enableInbound = watch("enable_inbound");
  const enableOutbound = watch("enable_outbound");
  const phoneNumber = watch("phone_number");

  return (
    <form onSubmit={widgetForm.handleSubmit(onSubmit)}>
      <ModalBody>
        <Stack spacing={4}>
          <Text fontSize="sm" color="gray.600" ml={1}>
            Enable our IP for SIP signals: <strong>54.236.168.131</strong>
          </Text>

          <Input
            placeholder="Phone Number (must include country code, e.g., 16501231234)"
            type="number"
            {...register("phone_number", { required: true })}
          />

          <Checkbox {...register("enable_outbound")}>
            Enable Outbound
          </Checkbox>

          {enableOutbound && (
            <>
              <Input
                placeholder="Termination Phone URI"
                {...register("termination_phone_uri", { required: true })}
              />
              <Input
                placeholder="SIP Username"
                {...register("sip_credentials.username", { required: true })}
              />
              <Input
                type="password"
                placeholder="SIP Password"
                {...register("sip_credentials.password", { required: true })}
              />
            </>
          )}

          <Checkbox {...register("enable_inbound")}>
            Enable Inbound
          </Checkbox>

          {enableInbound && (
            <>
              <Input
                placeholder="IP Address of origin server"
                {...register("incoming_sip_ip", { required: true })}
              />
              <Input
                type="number"
                placeholder="IP Subnet Mask"
                {...register("incoming_sip_netmask", { required: true })}
              />
              <Text fontSize="sm" color="gray.600" ml={1}>
                Set Origination SIP URI as:{" "}
                <strong>
                  sip:+{phoneNumber || "<Phone number>"}@sip.insighto.ai
                </strong>
              </Text>
            </>
          )}
        </Stack>
      </ModalBody>

      <ModalFooter>
        <Button mr={3} onClick={onBack}>
          Back
        </Button>
        <Button
          type="submit"
          isLoading={loadingStatus === "loading"}
          colorScheme="blue"
        >
          Finish
        </Button>
      </ModalFooter>
    </form>
  );
}
